import { useMemo } from 'react';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { useDecisionMakerResponsePageData } from 'src/app/pages/decisionMakerResponse/details/pageContext';

export function useUpdatePhoto() {
	const {
		data: { decisionMakerResponse },
	} = useDecisionMakerResponsePageData();
	const { resolveUrl } = useUtilityContext();

	return useMemo(() => {
		const { photo, embeddedMedia } = decisionMakerResponse;
		if (photo?.petitionLarge) {
			return {
				url: resolveUrl(photo.petitionLarge.url),
				width: photo.petitionLarge.width,
				height: photo.petitionLarge.height,
			};
		}
		const { thumbnailUrl, thumbnailWidth, thumbnailHeight } = embeddedMedia || {};
		if (thumbnailUrl && thumbnailWidth && thumbnailHeight) {
			return {
				url: resolveUrl(thumbnailUrl),
				width: thumbnailWidth,
				height: thumbnailHeight,
			};
		}
		return undefined;
	}, [decisionMakerResponse, resolveUrl]);
}
